import { Component } from '@angular/core';
import { ResultAlertError } from '@app/enums/errors.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-retry-error-modal',
  templateUrl: './retry-error-modal.component.html',
  styleUrls: ['./retry-error-modal.component.scss'],
  standalone: false,
})
export class RetryErrorModalComponent {
  constructor(private readonly modalService: NgbActiveModal) {}

  onRetry() {
    this.modalService.close(ResultAlertError.RETRY);
  }

  onCancel() {
    this.modalService.close(ResultAlertError.CANCEL);
  }
}
